import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

import { loading } from '../../util/loading';
import { toast } from '../../util/toast';
import { Validators as ValidatorsApp } from '../../util/validator';
import { ToastService } from '../../services/toast.service';
import { UsuarioService } from '../../services/usuario.service';

@Component({
    selector: 'app-convidar-usuario',
    templateUrl: './convidar-usuario.component.html',
    styleUrls: ['./convidar-usuario.component.scss']
})
export class ConvidarUsuarioComponent implements OnInit {

    perfis: any;

    convidarForm: FormGroup = new FormGroup({
        email: new FormControl('', [Validators.required, ValidatorsApp.email]),
        codigoPerfil: new FormControl('', ValidatorsApp.required),
    });

    constructor(
        private modalController: ModalController,
        private toastService: ToastService,
        private usuarioService: UsuarioService
    ) {
    }

    async ngOnInit() {
        this.perfis = await this.usuarioService.getPerfis().toPromise();
    }

    async dismiss() {
        await this.modalController.dismiss();
    }

    async convidar() {

        if (!this.convidarForm.valid) {
            return;
        }

        const result = this.usuarioService.convidarUsuario(this.convidarForm.value.email, this.convidarForm.value.codigoPerfil)
            .subscribe(async () => {
                await this.modalController.dismiss();
                toast('Usuario convidado com sucesso.');
            }, erro => {
                const message = erro.mensagem ? erro.mensagem : 'Não foi possível enviar o convite. Por favor tente mais tarde';
                toast(message);
            });
        loading(result);
    }

}
